var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8679 19.8104C19.5931 19.2261 19.3392 18.6295 19.0226 18.0678C18.7096 17.513 18.2366 17.0661 17.9618 16.4939C17.6922 15.9339 17.5566 15.3165 17.2279 14.7861C16.8818 14.2278 16.3809 13.7878 15.9983 13.2574C15.614 12.7252 15.3635 12.12 15.1009 11.5217C14.8435 10.9374 14.5426 10.4591 14.1218 9.98084C13.1913 8.92171 12.4661 7.72519 11.8661 6.45215C9.14961 6.53389 6.807 7.47997 4.89396 9.26954C2.91482 11.12 1.91309 13.4243 1.91309 16.1182C1.91309 18.8121 2.91309 21.1217 4.887 22.9948L4.89743 23.0052C6.89743 24.8539 9.37048 25.7913 12.247 25.7913C15.1235 25.7913 17.5948 24.8539 19.5966 23.0052L19.6018 23C20.1148 22.52 20.5618 22.0104 20.9444 21.4748C20.5235 20.9582 20.1496 20.4104 19.8679 19.8121V19.8104ZM14.7687 18.5478C14.094 19.1791 13.2696 19.4869 12.2487 19.4869C11.2279 19.4869 10.4087 19.1808 9.73396 18.5513C9.07656 17.9182 8.7583 17.1217 8.7583 16.1165C8.7583 15.1113 9.0783 14.3148 9.73396 13.6817C10.4087 13.0521 11.2313 12.7461 12.2487 12.7461C13.2661 12.7461 14.094 13.0539 14.7687 13.6852C15.4453 14.3182 15.774 15.113 15.774 16.1165C15.774 17.12 15.4453 17.913 14.7687 18.5478Z",
    fill: "url(#paint0_linear_2530_77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2123 22.2539C30.2123 21.447 30.2001 21.0418 30.2123 20.2348C30.2123 19.8974 30.0958 19.7009 29.9114 19.5409C29.7323 19.3844 29.2036 19.2922 29.1045 19.2713C27.0627 18.8644 26.0106 17.8574 24.8193 16.1513C23.4349 14.1687 22.2993 11.9913 20.7201 10.1444C19.3775 8.57568 17.6714 7.34785 15.6523 6.84002C14.4819 6.54437 13.2888 6.43655 12.0836 6.43481C8.00535 6.37046 5.41926 8.7635 4.89404 9.26959C4.89578 9.87133 5.07143 10.3461 5.32013 10.767C5.56883 11.1879 5.88709 11.5548 6.17752 11.9409C6.44187 12.2939 6.68361 12.6644 6.82274 13.1096C6.90274 13.3652 6.95143 13.647 6.95143 13.9635C6.95143 14.1426 11.2471 12.6505 12.0227 12.7478C13.7288 12.7478 14.6627 13.3339 15.6593 14.3705C17.141 15.9113 18.0853 17.8261 19.2836 19.5774C21.0332 22.1357 23.3306 24.7183 26.4714 25.4505C27.6193 25.7183 27.934 25.7896 29.108 25.7896C29.6245 25.7896 30.2158 25.4087 30.2158 24.8487V22.2522L30.2123 22.2539Z",
    fill: "url(#paint1_linear_2530_77)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2530_77",
    x1: 2.10265,
    y1: 14.1565,
    x2: 20.9931,
    y2: 18.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2530_77",
    x1: 9.42622,
    y1: 8.63133,
    x2: 29.6158,
    y2: 23.4226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzur);
export default __webpack_public_path__ + "static/media/AZUR.49e1633a1df66765bc46829b9bc5c7af.svg";
export { ForwardRef as ReactComponent };